import PropTypes from 'prop-types';
import style from './PostDate.module.css';
import formatDate from '../../../../../utils/formatDate';

export const PostDate = ({date}) => (
  <time className={style.date} dateTime={new Date(date).toISOString()}>
    {formatDate(date)}
  </time>
);

PostDate.propTypes = {
  date: PropTypes.number.isRequired,
};
